import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";

export const SubscribeToNewsletterElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  methods: {
    getExampleEntity() {
      return {};
    },
    async getRealEntity() {
      return {};
    },
  },
};
